import React from "react";
import styled from "styled-components";
import { theme } from "../../../../theme";

const ModalTitle: React.FC = ({ children }) => {
  return <StyledTitle>{children}</StyledTitle>;
};
export default ModalTitle;
const StyledTitle = styled.div`
  ${theme.typo.heading.b24};
  height: 32px;
`;
